exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram1-5d-1{min-height:940px}#diagram1-5d-1 .simplest__submit{bottom:-30px!important}#diagram1-5d-1 .r2-block__box{margin-top:16px;height:133px!important}#diagram1-5d-1 .framework-diagram__exercise-title{padding-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5d/diagram1/diagram1.scss
// module id = 1458
// module chunks = 0